import { ThemeProvider } from 'styled-components';

import { lightTheme } from 'theme';

import { PersonaId } from '../../personas';
import { buildHandle, getInitials, stars } from '../helpers';
import { PERSONA_MOCKS } from '../persona-mocks';
import * as styled from '../styles/loop-visual';

const FALLBACK_REVIEW = {
  author: 'Sarah J.',
  rating: 5,
  snippet: 'On time, every time. Wouldn\'t trust anyone else with my place.',
};

type Props = {
  personaId: PersonaId;
};

export const LoopVisual = ({ personaId }: Props) => {
  const mock = PERSONA_MOCKS[personaId];
  const review = mock.reviews[0] ?? FALLBACK_REVIEW;
  const handle = buildHandle(mock.displayName);
  const initials = getInitials(mock.displayName);

  return (
    <ThemeProvider theme={lightTheme}>
      <styled.LoopCard>
        <styled.LoopHeader>
          <styled.LoopKicker>The loop closes</styled.LoopKicker>
          <styled.LoopTitle>One review, multiplied</styled.LoopTitle>
          <styled.LoopSub>
            Every verified review becomes a branded social post — more eyes,
            more bookings, and the loop starts again.
          </styled.LoopSub>
        </styled.LoopHeader>

        <styled.Diagram>
          <styled.ReviewCard>
            <styled.ReviewBadge>🛡 Verified review</styled.ReviewBadge>
            <styled.ReviewStars aria-label={`${review.rating} stars`}>
              {stars(review.rating)}
            </styled.ReviewStars>
            <styled.ReviewQuote>"{review.snippet}"</styled.ReviewQuote>
            <styled.ReviewMeta>— {review.author}</styled.ReviewMeta>
          </styled.ReviewCard>

          <styled.ArrowCol aria-hidden>
            <span>→</span>
          </styled.ArrowCol>

          <styled.PostCard>
            <styled.PostHeader>
              <styled.PostAvatar>
                <styled.PostAvatarInner>{initials}</styled.PostAvatarInner>
              </styled.PostAvatar>
              <styled.PostHandle>
                <styled.PostName>{handle}</styled.PostName>
                <styled.PostSub>Sponsored · via Kudable</styled.PostSub>
              </styled.PostHandle>
            </styled.PostHeader>
            <styled.PostBody>
              <styled.PostQuoteMark aria-hidden>"</styled.PostQuoteMark>
              <styled.PostQuote>{review.snippet}</styled.PostQuote>
              <styled.PostAttribution>
                {stars(review.rating)} · {review.author}
              </styled.PostAttribution>
            </styled.PostBody>
            <styled.PostFooter>
              <span>Book direct</span>
              <styled.PostLink>kudable.com/p/{handle.slice(1)}</styled.PostLink>
            </styled.PostFooter>
          </styled.PostCard>
        </styled.Diagram>
      </styled.LoopCard>
    </ThemeProvider>
  );
};
